import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=09c5d790&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5d790",
  null
  
)

export default component.exports